import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import HomePage from './pages/HomePage';
import DocumentPage from './pages/DocumentPage';
import ValidationPage from './pages/ValidationPage';
import UserManagementPage from './pages/admin/UserManagementPage';
import TaskAssignmentPage from './pages/admin/TaskAssignmentPage';
import ProtectedRoute from './components/ProtectedRoute';
import ModelPlaygroundPage from './pages/ModelPlaygroundPage';
import ModelManagementPage from './pages/admin/ModelManagementPage';
import SystemDashboardPage from './pages/admin/SystemDashboardPage';
import SystemSettingsPage from './pages/admin/SystemSettingsPage';
import SystemSlidesManagementPage from './pages/admin/SystemSlidesManagementPage';
import NewsletterSubscribersPage from './pages/admin/NewsletterSubscribersPage';
import UserProfilePage from './pages/UserProfilePage';
import AnalyticsPage from './pages/admin/AnalyticsPage';

import useAuthStore from './stores/authStore';
import { getCurrentUser } from './services/authService';

// Create a client
const queryClient = new QueryClient();

function App() {
  const { user, token, setUser } = useAuthStore();

  React.useEffect(() => {
    const refreshUser = async () => {
      console.log('🔄 App Component Hydrated. Current user in store:', user?.email, 'Role:', user?.role);
      if (token && user) {
        try {
          console.log('📡 Fetching fresh user profile from server...');
          const updatedUser = await getCurrentUser();
          console.log('✅ Fresh user received:', updatedUser.email, 'Role:', updatedUser.role);
          setUser(updatedUser, token);
        } catch (error) {
          console.error('❌ Failed to refresh user profile:', error);
        }
      } else if (token && !user) {
        console.log('📡 Token exists but no user. Fetching user...');
        try {
          const updatedUser = await getCurrentUser();
          setUser(updatedUser, token);
        } catch (error) {
          console.error('❌ Failed to fetch user with token:', error);
        }
      }
    };
    refreshUser();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/admin/users" element={<UserManagementPage />} />
          <Route path="/admin/tasks" element={<TaskAssignmentPage />} />
          <Route path="/admin/models" element={<ModelManagementPage />} />
          <Route path="/admin/system" element={<SystemDashboardPage />} />
          <Route path="/admin/settings" element={<SystemSettingsPage />} />
          <Route path="/admin/slides-management" element={<SystemSlidesManagementPage />} />
          <Route path="/admin/newsletter-subscribers" element={<NewsletterSubscribersPage />} />
          <Route path="/admin/analytics" element={<AnalyticsPage />} />
          <Route path="/profile" element={<UserProfilePage />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/documents" element={<DocumentPage />} />
          <Route path="/validate" element={<ValidationPage />} />
          <Route path="/playground" element={<ModelPlaygroundPage />} />
        </Route>
      </Routes>
    </QueryClientProvider>
  );
}

export default App;
